<template>
  <div class="overflow-hidden border border-zt-light"
       :class="{ '!mt-0 border-x-0 xl:border-x' : variant === 'main-page',
                 'rounded-zt ' : variant === 'default' || variant === 'live' || variant === 'line',
                 '!rounded-b-zt' : roundBottom,
                 'mt-3': variant !== 'euro-group-phase' || window.size.mobile }">
    <div v-if="matches.length !== 0" class="bg-zt-light-full border-b border-zt-light w-full h-10 flex items-center pl-3.5 pr-[9px] gap-[5px]"
         :class="{ 'rounded-t-zt' : variant === 'default' || variant === 'live' || variant === 'line' }">
      <div v-if="variant === 'euro-group-phase'" class="flex flex-nowrap gap-x-2 items-center">
        <div class="w-[15px] h-[11px] bg-white">
          <img ref="countryFlag" :src="'/wp-content/themes/zawodtyper/assets/images/staty_football/countryfallback.svg'"
               class="h-[11px] rounded-sm block overflow-hidden mx-auto"
               :data-src="`/wp-content/themes/zawodtyper/assets/images/ligi/swiat-euro.png`"
               alt="Euro 2024" width="10" height="11"/>
        </div>
        <span class="text-xs">EURO 2024: {{ groupName }}</span>
      </div>
      <div v-else-if="league.league_query_name.length > 0 && (!Object.hasOwn(league, 'league_hidden') || Number(league.league_hidden) === 0)"
           class="flex flex-nowrap gap-x-2 items-center w-full justify-between">
        <div class="flex items-center gap-x-2">
          <a class="no-default-style flex zt-hover items-center gap-x-2" target="_self" :data-count-click="analyticsText"
             :href="`/wyniki-pilka-nozna/${league.country_query_name}/${league.league_query_name}/${matches.every(match => match.round?.includes('Qualifying')) ? 'kwalifikacje/' : ''}`">
            <img ref="countryFlag" :src="'/wp-content/themes/zawodtyper/assets/images/staty_football/countryfallback.svg'"
                 class="w-[15px] h-[11px] rounded-sm block overflow-hidden"
                 :data-src="`/wp-content/themes/zawodtyper/assets/images/kraje/${league.country_query_name}.svg`"
                 :alt="league.country_name"/>
            <h2 v-if="WP.path === '/wyniki-pilka-nozna/'" class="no-default-style text-xs"
                :class="{ 'underline' : leagueUnderline }">
                {{ ['Świat', 'Europa'].includes(league.country_name) ? '' : league.country_name?.toUpperCase() + ': '}}{{league.league_name}} {{matches.every(match => match.round?.includes('Qualifying')) ? '- Eliminacje' : ''}}
            </h2>
            <span v-else class="text-xs" :class="{ 'underline' : leagueUnderline }">
              {{ ['Świat', 'Europa'].includes(league.country_name) ? '' : league.country_name?.toUpperCase() + ': '}}{{league.league_name}} {{matches.every(match => match.round?.includes('Qualifying')) ? '- Eliminacje' : ''}}
            </span>
          </a>
          <svg v-if="showStar" width="12" height="11" class="inline-block" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3.80897 3.416C3.80897 3.416 1.7023 3.64933 0.296968 3.80533C0.170302 3.82067 0.0583017 3.90533 0.0163017 4.034C-0.0256983 4.16267 0.0163017 4.29667 0.109635 4.38133C1.15364 5.334 2.7223 6.76067 2.7223 6.76067C2.72097 6.76067 2.29164 8.836 2.0063 10.2207C1.9823 10.346 2.02764 10.4787 2.13697 10.558C2.24564 10.6373 2.38564 10.6387 2.49564 10.5767C3.72497 9.878 5.5663 8.82733 5.5663 8.82733C5.5663 8.82733 7.4083 9.878 8.63564 10.5773C8.74763 10.6387 8.88764 10.6373 8.9963 10.558C9.10564 10.4787 9.15097 10.346 9.1263 10.2213C8.84097 8.836 8.4123 6.76067 8.4123 6.76067C8.4123 6.76067 9.98097 5.334 11.025 4.38333C11.1183 4.296 11.1596 4.162 11.1183 4.034C11.077 3.906 10.965 3.82133 10.8383 3.80667C9.43297 3.64933 7.32564 3.416 7.32564 3.416C7.32564 3.416 6.4523 1.484 5.8703 0.196C5.81564 0.0806668 5.70097 0 5.5663 0C5.43164 0 5.3163 0.0813334 5.2643 0.196C4.68163 1.484 3.80897 3.416 3.80897 3.416Z" fill="white"/>
          </svg>
        </div>
        <a v-if="showTableIcon && (!league.league_type.toLowerCase().includes('cup') || [2, 3, 848].includes(+league.league_id))" class="no-default-style zt-hover" data-count-click="Ikonka <tabela> w WYNIKACH NA Ż"
           :href="`/wyniki-pilka-nozna/${league.country_query_name}/${league.league_query_name}/${matches.every(match => match.round?.includes('Qualifying')) ? 'kwalifikacje/' : 'tabela/'}`">
          <svg xmlns="http://www.w3.org/2000/svg" width="26" height="19" viewBox="0 0 26 19" fill="none">
            <path d="M25.2188 1.73913C25.2188 1.33092 24.8878 1 24.4796 1H6.00136V3.21739H24.4796C24.8878 3.21739 25.2188 2.88647 25.2188 2.47826V1.73913Z" fill="#93A3BA"/>
            <path d="M19.3057 8.73913C19.3057 8.33092 18.9747 8 18.5665 8H6.00132V10.2174H18.5665C18.9747 10.2174 19.3057 9.88647 19.3057 9.47826V8.73913Z" fill="#93A3BA"/>
            <path d="M21.5234 16.5223C21.5234 16.1141 21.1925 15.7832 20.7843 15.7832H6.0017V18.0006H20.7843C21.1925 18.0006 21.5234 17.6697 21.5234 17.2615V16.5223Z" fill="#93A3BA"/>
            <circle cx="2" cy="2" r="2" fill="#93A3BA"/>
            <circle cx="2" cy="9" r="2" fill="#93A3BA"/>
            <circle cx="2" cy="17" r="2" fill="#93A3BA"/>
          </svg>
        </a>
      </div>
      <div v-else-if="+league.league_id === 34 || +league.league_id === 32">
        <a class="no-default-style flex zt-hover items-center gap-x-2" target="_self" :data-count-click="analyticsText"
           href="/wyniki-pilka-nozna/swiat/mundial/kwalifikacje/">
          <img ref="countryFlag" :src="'/wp-content/themes/zawodtyper/assets/images/staty_football/countryfallback.svg'"
               class="w-[15px] h-[11px] rounded-sm block overflow-hidden"
               :data-src="`/wp-content/themes/zawodtyper/assets/images/kraje/${league.country_query_name}.svg`"
               :alt="league.country_name"/>
          <span class="text-xs" :class="{ 'underline' : leagueUnderline }">
                El. Mistrzostw Świata ({{ +league.league_id === 34 ? 'Ameryka Poł.' : 'Europa' }})
           </span>
          <svg v-if="showStar" width="12" height="11" class="inline-block" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3.80897 3.416C3.80897 3.416 1.7023 3.64933 0.296968 3.80533C0.170302 3.82067 0.0583017 3.90533 0.0163017 4.034C-0.0256983 4.16267 0.0163017 4.29667 0.109635 4.38133C1.15364 5.334 2.7223 6.76067 2.7223 6.76067C2.72097 6.76067 2.29164 8.836 2.0063 10.2207C1.9823 10.346 2.02764 10.4787 2.13697 10.558C2.24564 10.6373 2.38564 10.6387 2.49564 10.5767C3.72497 9.878 5.5663 8.82733 5.5663 8.82733C5.5663 8.82733 7.4083 9.878 8.63564 10.5773C8.74763 10.6387 8.88764 10.6373 8.9963 10.558C9.10564 10.4787 9.15097 10.346 9.1263 10.2213C8.84097 8.836 8.4123 6.76067 8.4123 6.76067C8.4123 6.76067 9.98097 5.334 11.025 4.38333C11.1183 4.296 11.1596 4.162 11.1183 4.034C11.077 3.906 10.965 3.82133 10.8383 3.80667C9.43297 3.64933 7.32564 3.416 7.32564 3.416C7.32564 3.416 6.4523 1.484 5.8703 0.196C5.81564 0.0806668 5.70097 0 5.5663 0C5.43164 0 5.3163 0.0813334 5.2643 0.196C4.68163 1.484 3.80897 3.416 3.80897 3.416Z" fill="white"/>
          </svg>
        </a>
      </div>
      <div v-else class="flex flex-nowrap gap-x-2 items-center">
        <img ref="countryFlag" :src="'/wp-content/themes/zawodtyper/assets/images/staty_football/countryfallback.svg'"
             class="w-[15px] h-[11px] rounded-sm block overflow-hidden"
             :data-src="`/wp-content/themes/zawodtyper/assets/images/kraje/${league.country_query_name}.svg`"
             :alt="league.country_name"/>
        <span class="text-xs">{{league.country_name?.toUpperCase()}}: {{league.league_name}}</span>
        <svg v-if="showStar" width="12" height="11" class="inline-block" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M3.80897 3.416C3.80897 3.416 1.7023 3.64933 0.296968 3.80533C0.170302 3.82067 0.0583017 3.90533 0.0163017 4.034C-0.0256983 4.16267 0.0163017 4.29667 0.109635 4.38133C1.15364 5.334 2.7223 6.76067 2.7223 6.76067C2.72097 6.76067 2.29164 8.836 2.0063 10.2207C1.9823 10.346 2.02764 10.4787 2.13697 10.558C2.24564 10.6373 2.38564 10.6387 2.49564 10.5767C3.72497 9.878 5.5663 8.82733 5.5663 8.82733C5.5663 8.82733 7.4083 9.878 8.63564 10.5773C8.74763 10.6387 8.88764 10.6373 8.9963 10.558C9.10564 10.4787 9.15097 10.346 9.1263 10.2213C8.84097 8.836 8.4123 6.76067 8.4123 6.76067C8.4123 6.76067 9.98097 5.334 11.025 4.38333C11.1183 4.296 11.1596 4.162 11.1183 4.034C11.077 3.906 10.965 3.82133 10.8383 3.80667C9.43297 3.64933 7.32564 3.416 7.32564 3.416C7.32564 3.416 6.4523 1.484 5.8703 0.196C5.81564 0.0806668 5.70097 0 5.5663 0C5.43164 0 5.3163 0.0813334 5.2643 0.196C4.68163 1.484 3.80897 3.416 3.80897 3.416Z" fill="white"/>
        </svg>
      </div>
    </div>
    <div v-if="matches.length !== 0" v-for="(match, index) of matches" :key="match.id">
      <FootballStatsListItem
        class="border-x-0"
        :redirect-to-h2h="match.is_h2h_available"
        :class="{ 'border-b-0' : index === matches.length - 1 }"
        :match="match"
        :filtering-result="showResults ? calculateFilterResult(match) : ''"
        :show-odds="showOdds"
        :variant="variant"
        :show-scores="showScores"
        :show-hour="showHour"
        :show-date="showDate"
        :show-h2h-button="showH2hButton"
        :show-finished="showFinished"
        :show-teams-bg="showTeamsBgs"
        :show-live-matches-h2h-button="showLiveMatchesH2hButton"
        :hour-only-in-todays-matches="hourOnlyInTodaysMatches"
        :show-standings-icon="showStandingsIcon"
        :show-event-arrow="showEventArrow"
        :show-promotion-icon="checkPromotionIcon(match, league)"
      />
    </div>
    <p v-if="matches.length === 0" class="text-xs border-zt-light text-zt-more text-center font-normal w-full -leading-[0.18px] bg-zt-light-full py-2.5">
      Brak meczów do wyświetlania
    </p>
  </div>
</template>

<script>
import utils_mixin from '../../mixins/utils_mixin';
import FootballStatsListItem from './FootballStatsListItem.vue';
import { lazyLoad } from '../../../assets/js/utils';
import football_mixin from "../../mixins/football_mixin";

export default {
  name: 'FootballStatsList',
  inject: ['WP'],
  components: { FootballStatsListItem },
  mixins: [utils_mixin, football_mixin],
  props: {
		roundBottom: {
			type: Boolean,
			default: false,
		},
    showStandingsIcon: {
      type: Boolean,
      default: false
    },
    league: Object, // league_name, country_name, flag, league_type
    matches: {
      type: Array,
      default: [],
    },
    showScores: {
      type: Boolean,
      default: false,
    },
    showResults: {
      type: Boolean,
      default: false,
    },
    teamId: {
      type: Number,
      default: -1,
    },
    showOdds: {
      type: Boolean,
      default: false,
    },
    showHour: {
      type: Boolean,
      default: false,
    },
    showDate: {
      type: Boolean,
      default: false,
    },
    showFinished: {
      type: Boolean,
      default: false,
    },
    hourOnlyInTodaysMatches: {
      type: Boolean,
      default: false,
    },
    showStar: {
      type: Boolean,
      default: false,
    },
    variant: {
      type: String,
      default: 'default'
    },
    showH2hButton: {
      type: Boolean,
      default: false
    },
    showLiveMatchesH2hButton: {
      type: Boolean,
      default: false
    },
    analyticsText: {
      type: String,
      default: ''
    },
    leagueUnderline: {
      type: Boolean,
      default: false
    },
    groupName: {
      type: String,
      default: '',
    },
	  showTableIcon: {
			type: Boolean,
		  default: false
	  },
    showTeamsBgs: {
      type: Array,
      default: []
    },
    showEventArrow: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showMatches: true,
    }
  },
  mounted() {
    this.$nextTick(() => lazyLoad([this.$refs.countryFlag]));
  },
  methods: {
    calculateFilterResult(match) {
      const matchResult = +match.localteam_id === this.teamId ? +match.localteam_goals - +match.visitorteam_goals : +match.visitorteam_goals - +match.localteam_goals;
      return matchResult > 0 ? 'W' : matchResult === 0 ? 'R' : 'P';
    },
  },
}
</script>